import { useTranslation } from 'react-i18next';
import { NotePencil } from '@phosphor-icons/react';
import { Badge } from '@/components/ui-kit/badge';
import { cn } from '@/lib/utils';
import { AttendanceCorrection } from '../../types/attendance.types';

/** Outlined chips: the status color on the border and text, no fill. */
export const CORRECTION_STATUS_STYLE: Record<AttendanceCorrection['Status'], string> = {
  Pending: 'border-warning text-warning',
  Approved: 'border-success text-success',
  Rejected: 'border-error text-error',
};

/** A correction request's status as a chip; `withIcon` marks it as a correction where nothing else
 * says so (a calendar day), the full "Correction: <status>" stays in its tooltip. */
export const CorrectionStatusTag = ({
  status,
  withIcon = false,
  className,
}: {
  status: AttendanceCorrection['Status'];
  withIcon?: boolean;
  className?: string;
}) => {
  const { t } = useTranslation();
  const statusLabel = t(status.toUpperCase());
  return (
    <Badge
      variant="outline"
      title={`${t('CORRECTION')}: ${statusLabel}`}
      className={cn(
        'w-fit font-medium',
        CORRECTION_STATUS_STYLE[status] ?? 'text-muted-foreground',
        withIcon && 'gap-1',
        className
      )}
    >
      {withIcon && <NotePencil className="size-3 shrink-0" />}
      {statusLabel}
    </Badge>
  );
};
